<template>
    <div>
        <v-btn
            @click="$refs.actualUpload.click()"
            color="primary"
            small
            :loading="isUploadLoading"
        >
            <v-icon left>mdi-upload</v-icon>
            Upload
        </v-btn>

        <input
            @input="upload"
            type="file"
            accept="application/json"
            class="d-none"
            ref="actualUpload"
        >

        <v-btn @click="download" color="primary" small class="ml-2">
            <v-icon left>mdi-download</v-icon>
            Download
        </v-btn>

        <a :href="downloadUrl" download class="d-none" ref="actualDownload"></a>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
        }
    },

    data: () => ({
        downloadUrl: null,
        isUploadLoading: false,
        uploadedFile: null,
    }),

    methods: {
        async upload(e) {
            const files = e.target.files
            if (files.length === 0) {
                return
            }

            this.isUploadLoading = true

            const file = files[0]
            const text = await file.text()
            const tryouts = JSON.parse(text)
            console.log(tryouts)
            for (const tryoutIdx in tryouts) {
                const tryout = tryouts[tryoutIdx]
                const questionIds = tryout.questions.map(question => question.id)
                const response = await this.$apiv2.get('question-import/questions', {
                    params: {
                        questionIds: questionIds
                    }
                })
                const remoteQuestions = response.data.questions

                for (const questionIdx in tryout.questions) {
                    const question = tryout.questions[questionIdx]

                    tryouts[tryoutIdx].questions[questionIdx] = remoteQuestions
                        .find(remoteQuestion => remoteQuestion.id == question.id)
                }
            }
            this.isUploadLoading = false

            this.$emit('input', tryouts)
        },

        download() {
            const processedTryout = this.value
                .map(tryout => ({
                    period: tryout.period,
                    tryout: tryout.tryout,
                    questions: tryout.questions
                        .map(question => ({
                            id: question.id
                        }))
                }))

            const json = JSON.stringify(processedTryout)
            const blob = new Blob(json.split(), { type: 'application/json' })
            this.downloadUrl = URL.createObjectURL(blob)
            this.$nextTick(() => this.$refs.actualDownload.click())
        },
    }
}
</script>
